import React from 'react'
import { environment } from '@env';
const Header = () => {
    // Use env.ENV_NAME or similar, depending on your environment file
    const envName = environment.ENV_NAME || '';
    return (
        <header className=" bg-[#1b1534] h-[102.4px] flex items-center  justify-center">
            <img className="w-[150px] ml-[80px] mr-[288px]" src="assets/Siemens_Logo.png"></img>
            <a className="h-[21px] w-full text-white font-extrabold text-[18px] font-default">Dry Gas Seal</a>
            <a className="h-[21px] w-full text-[#c0bebe] font-extrabold font-default text-[18px]"> {envName} </a>
        </header>
    )
}

export default Header;